@if (currentClient.status === 'ACTIVE') {
  <div class="row g-4 mb-3">
    <div class="col-sm-auto">
      <div>
        <button type="button" class="btn btn-success add-btn me-1" (click)="openModal()">
          <i class="ri-add-line align-bottom me-1"></i> Add New Plan </button>
        </div>
      </div>
    </div>
  }

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th>Plan Name</th>
          <th>Plan Cycle</th>
          <th>Start Date</th>
          <th>Expiration Date</th>
          <th>Factors</th>
          <th>Examinees</th>
          <th>Video Usage (Minutes)</th>
          <th>Price</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="9" class="text-center">
              <app-loading-spinner></app-loading-spinner>
            </td>
          </tr>
        }
        @if (!loading && plans && plans.length > 0) {
          @for (plan of plans; track plan) {
            <tr>
              <td>{{ plan.name }}</td>
              <td>{{ plan.plan_cycle | titlecase }}</td>
              <td>{{ plan.started_at | date }}</td>
              <td>{{ plan.expired_at ? (plan.expired_at | date) : 'Unlimited' }}</td>
              <td>
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <ul class="list-inline tasks-list-menu mb-0">
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration.skin_analysis ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration.skin_analysis ? 'Enabled' : 'Disabled'">Skin</span>
                      </li>
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration.voice_analysis ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration.voice_analysis ? 'Enabled' : 'Disabled'">Voice</span>
                      </li>
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration.bl_analysis ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration.bl_analysis ? 'Enabled' : 'Disabled'">Body Language</span>
                      </li>
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration.emotion_analysis ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration.emotion_analysis ? 'Enabled' : 'Disabled'">Emotion</span>
                      </li>
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration['head-pose_analysis'] ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration['head-pose_analysis'] ? 'Enabled' : 'Disabled'">Head Position</span>
                      </li>
                      <li class="list-inline-item">
                        <span class="badge rounded-pill"
                          [ngClass]="plan.configuration.api_access ? 'bg-success-subtle text-success' : 'bg-dark-subtle text-body text-muted'"
                        [ngbTooltip]="plan.configuration.api_access ? 'Enabled' : 'Disabled'">External API</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
              <td>{{ plan.configuration.examinees }}</td>
              <td>{{ plan.configuration.video_minutes }}</td>
              <td>{{ plan.configuration.price | currency:'USD':'symbol' }}</td>
              <td class="status">
                <span
                  class="badge text-uppercase"
                  [ngClass]="getStatus(plan) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                  {{ getStatus(plan) ? 'Active' : 'Expired' }}
                </span>
              </td>
              <td>
                <div class="d-flex gap-2">
                  @if (getStatus(plan)) {
                    <div class="edit">
                      <button class="btn btn-sm btn-info edit-item-btn" ngbTooltip="Edit plan" alt="Edit plan" (click)="openModal(plan)"><i class="ri-pencil-fill"></i></button>
                    </div>
                  }
                  @if (getStatus(plan)) {
                    <div class="remove">
                      <button class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Cancel plan" alt="Cancel plan" (click)="openCancelModal(plan)"><i class="ri-close-circle-fill"></i></button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
        @if (!loading && plans && plans.length === 0) {
          <tr>
            <td colspan="9" class="text-center">No Plans were found.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <ng-template #createPlanModal let-modal>
    <div class="modal-content">
      <div class="modal-header p-3">
        <h4 class="card-title mb-0">Create New Plan</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="createForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="name" class="form-label">Plan name @if (!editMode) {
              <span class="text-danger">*</span>
            }</label>
            <input type="text" class="form-control" id="name" placeholder="Enter plan name" required formControlName="name" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            <div class="invalid-feedback"> Please enter plan name </div>
          </div>
          <div class="mb-3">
            <label for="plan_cycle" class="form-label">Plan Cycle <span class="text-danger">*</span></label>
            <ng-select id="plan_cycle" [items]="plan_cycles" bindLabel="name" bindValue="value" [clearable]="false" placeholder="Select a plan_cycle" formControlName="plan_cycle" [ngClass]="{ 'is-invalid': submitted && f['plan_cycle'].errors }" required></ng-select>
            <div class="invalid-feedback"> Please select plan_cycle </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-6">
                <label for="started_at" class="form-label">Start Date @if (!editMode) {
                  <span class="text-danger">*</span>
                }</label>
                @if (!editMode) {
                  <input class="form-control flatpickr-input" type="text" mwlFlatpickr [placeholder]="'Enter Start Date'" [altInput]="false" [altFormat]="'Y-m-d H:i'" [minDate]="minStartDate" [enableTime]="false" [dateFormat]="'Y-m-d'" [convertModelValue]="false" formControlName="started_at" [ngClass]="{ 'is-invalid': submitted && f['started_at'].errors }">
                }
                @if (editMode) {
                  <input type="text" class="form-control" id="started_at" placeholder="Enter start date" required formControlName="started_at">
                }
                <div class="invalid-feedback"> Please enter start date </div>
              </div>
              <div class="col-6">
                <label for="expired_at" class="form-label">Expiration Date (optional)</label>
                @if (!editMode) {
                  <input class="form-control flatpickr-input" type="text" mwlFlatpickr [placeholder]="'Enter End Date'" [altInput]="false" [altFormat]="'Y-m-d H:i'" [minDate]="minExpiryDate" [enableTime]="false" [dateFormat]="'Y-m-d'" [convertModelValue]="false" formControlName="expired_at">
                }
                @if (editMode) {
                  <input type="text" class="form-control" id="expired_at" placeholder="Unlimited" required formControlName="expired_at">
                }
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="price" class="form-label">Price <span class="text-danger">*</span></label>
            <input type="number" class="form-control" id="price" placeholder="Enter price" required formControlName="price" [ngClass]="{ 'is-invalid': submitted && f['price'].errors }">
            <div class="invalid-feedback"> Please enter price </div>
          </div>
          <div class="mb-3">
            <label for="examinees" class="form-label">Examinees count <span class="text-danger">*</span></label>
            <input type="number" class="form-control" id="examinees" placeholder="Enter examinees count" required formControlName="examinees" [ngClass]="{ 'is-invalid': submitted && f['examinees'].errors }">
            <div class="invalid-feedback"> Please enter examinees count </div>
          </div>
          <div class="mb-3">
            <label for="video_minutes" class="form-label">Video Minutes <span class="text-danger">*</span></label>
            <input type="number" class="form-control" id="video_minutes" placeholder="Enter video minutes" required formControlName="video_minutes" [ngClass]="{ 'is-invalid': submitted && f['video_minutes'].errors }">
            <div class="invalid-feedback"> Please enter video minutes </div>
          </div>

          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="api_access" [checked]="api_access" (change)="onCheckedDone('api')">
            <label class="form-check-label" for="api_access">External API Access</label>
            <p class="form-check-label" for="api_access">**Giving the admin the access to create api keys for api calls</p>
          </div>

          <h4 class="card-title mb-3">Factor Section</h4>
          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="skin_analysis" [checked]="skin_analysis" (change)="onCheckedDone('skin')">
            <label class="form-check-label" for="skin_analysis">Skin Analysis</label>
          </div>
          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="voice_analysis" [checked]="voice_analysis" (change)="onCheckedDone('voice')">
            <label class="form-check-label" for="voice_analysis">Voice Analysis</label>
          </div>
          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="bl_analysis" [checked]="bl_analysis" (change)="onCheckedDone('bl')">
            <label class="form-check-label" for="bl_analysis">Body Language Analysis (Engagment + Leaks)</label>
          </div>
          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="emotion_analysis" [checked]="emotion_analysis" (change)="onCheckedDone('emotion')">
            <label class="form-check-label" for="emotion_analysis">Emotion Analysis (Face Landmarks)</label>
          </div>
          <div class="form-check form-check-success mb-3">
            <input class="form-check-input" type="checkbox" id="head_pose_analysis" [checked]="head_pose_analysis" (change)="onCheckedDone('headpose')">
            <label class="form-check-label" for="head_pose_analysis">Head Position Analysis</label>
          </div>
          @if (!skin_analysis && !bl_analysis && !voice_analysis && !emotion_analysis && submitted) {
            <div class="invalid-factors">** One of the factors must be selected! </div>
          }
          <div class="text-end">
            <button type="submit" class="btn btn-primary btn-load">
              <span class="d-flex justify-content-center">
                @if (submitted && spinner) {
                  <span class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                }
                <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ editMode ? 'Edit' : 'Create' }} </span>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ success ? 'Create Plan Success.' : 'Create Plan Error!'}}</h4>
          <p class="text-muted mx-4 mb-0">{{ message }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #cancelModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to cancel this plan?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="cancelPlan()">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Cancel It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>